import Button from '@creditflowresearch/uilib/Button';
import IconSparkle from '@creditflowresearch/uilib/Icon/IconSparkle';
import IconSparkleGradient from '@creditflowresearch/uilib/Icon/IconSparkleGradient';
import { panelManager } from '@creditflowresearch/uilib/PanelControl/panelManager';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { useAiSidebarContext } from '@/creditflowresearch/application/AiSidebar/AiSidebarContext';

import styles from './askAiButton.module.scss';

const AskAiMobileButton = () => {
  const { isOpen, toggle } = useAiSidebarContext();
  const { checkAccessByUserPlan } = useUserPlanContext();
  const hasAccess = checkAccessByUserPlan(UserPlanType.PREMIUM);
  const Sparkle = hasAccess ? IconSparkleGradient : IconSparkle;

  const handleClick = () => {
    panelManager.close();
    toggle();
  };

  return (
    <Button
      variant="outline"
      size="S"
      icon={ <Sparkle /> }
      iconSize={ 14 }
      onClick={ handleClick }
      disabled={ !hasAccess }
      aria-expanded={ isOpen }
      ariaLabel="Ask AI"
      className={ styles.button }
      dataTest="askAiMobileButton"
    />
  );
};

export default AskAiMobileButton;
